import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/App";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import api from "@/lib/api";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { login } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const res = await api.post("/auth/login", { email, password });
      login(res.data.user, res.data.token);
      navigate("/admin");
    } catch (err) {
      setError(err.response?.data?.detail || "Неверные данные для входа");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4" data-testid="admin-login-page">
      <div className="w-full max-w-sm">
        <div className="text-center mb-10">
          <img src="https://customer-assets.emergentagent.com/job_70076dd7-e4cb-484b-b629-fe23ba9127e6/artifacts/3zpuxtd5_LOGO.PNG" alt="Eco Village" className="h-14 mx-auto mb-3" />
          <p className="text-sm text-muted-foreground">Админ-панель</p>
        </div>
        <form onSubmit={handleSubmit} className="space-y-4">
          <Input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Email"
            className="bg-card border-white/10 rounded-none py-5"
            data-testid="login-email-input"
            required
          />
          <Input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Пароль"
            className="bg-card border-white/10 rounded-none py-5"
            data-testid="login-password-input"
            required
          />
          {error && <p className="text-red-400 text-sm" data-testid="login-error">{error}</p>}
          <Button type="submit" disabled={loading} className="w-full bg-primary text-primary-foreground rounded-none py-5 uppercase tracking-widest text-sm" data-testid="login-submit-btn">
            {loading ? "Вход..." : "Войти"}
          </Button>
        </form>
      </div>
    </div>
  );
}
